<template>
	<div :class="`colHalf rubric cat${this.coachingCategory.id}`">
		<ul>
			<li>
				<span>{{coachingCategory.name}}</span>
				<span>{{parseInt(coachingCategory.percentage)}}%</span>
			</li>
			<li v-for="question in coachingCategory.questions" :key="question.id">
				<span>{{question.name}}</span>
				<span>{{parseInt(question.percentage)}}%</span>
			</li>
		</ul>
	</div>
</template>

<script>
export default {
	props: ['coachingCategory']
};
</script>

<style lang="scss" scoped>
@import "../../scss/global.scss";

.rubric {
	padding: 0 1rem;
	margin: 2rem 0;
	align-items: flex-start;
	min-width: 45.6rem;
	min-height: 24.6rem;
	&.cat1 {
		border-left: 0.5rem solid $cat1;
	}
	&.cat2 {
		border-left: 0.5rem solid $cat2;
	}
	&.cat3 {
		border-left: 0.5rem solid $cat3;
	}
	&.cat4 {
		border-left: 0.5rem solid $cat4;
	}
	&>ul {
		padding: 0 0 0 2rem;
		list-style-type: none;
		width: 100%;
		&>li {
			display: flex;
			justify-content: space-between;
			position: relative;
			&>span {
				font-size: $regularSize;
				font-weight: 400;
				text-indent: 3.6rem;
				color: $semiBlack;
				margin: 1.2rem 0;
			}
			&:first-child {
				& span {
					font-size: $smallTitle;
					font-weight: 700;
					text-indent: 0;
					color: $oxfordBlue;
				}
				&:before {
					display: none;
				}
			}
			&:before {
				content: '';
				border-left: 0.2rem solid $dawnBlue;
				border-bottom: 0.2rem solid $dawnBlue;
				display: block;
				width: 2rem;
				height: 5rem;
				position: absolute;
				top: -2.2rem;
				left: 1.2rem;
			}
			&:nth-child(2) {
				&:before {
					top: -0.4rem;
					height: 3rem;
				}
			}
		}
	}
	&Table {
		flex: 1 1 auto;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/ui/PercentagesSummary.vue